import _ from 'lodash';

export function getMessageByCodeAndLanguage({ code, lang, loginUrl }) {
    code = _.toNumber(code);
    let data = {
        en: '',
    };
    let title = {
        en: '',
    };
    if (code === 30101 || code === 30103 || code === 30113 || code === 180102) {
        title = {
            en: 'Incorrect username or password',
            cn: '用户名密码错误',
            tw: '用戶名密碼錯誤',
            jp: 'パスワードが間違っています。',
        };
        data = {
            en: 'The email address or password you entered is incorrect. Please try again. If you have forgotten your password, please click <a class="error-code-target" data-code="30103" href="<%- href %>">here</a>.',
            cn: '您输入的邮箱或密码错误，请重试。如果您忘记了密码，请点击<a class="error-code-target" data-code="30103" href="<%- href %>">这里</a>。',
            tw: '您輸入的郵箱或密碼錯誤，請重試。如果您忘記了密碼，請點擊<a class="error-code-target" data-code="30103" href="<%- href %>">這裡</a>。',
            jp: 'パスワードまたはメールアドレスが間違っていますので、新たにお試しください。パスワードをお忘れの方は<a class="error-code-target" data-code="30103" href="<%- href %>">ここ</a>をクリックしてください。',
        };
    }

    if (code === 30103.1) { // 手机号密码错误
        title = {
            en: 'Incorrect username or password',
            cn: '用户名密码错误',
            tw: '用戶名密碼錯誤',
            jp: 'パスワードが間違っています。',
        };
        data = {
            en: 'The mobile number or password you entered is incorrect. Please try again. If you have forgotten your password, please click <a class="error-code-target" data-code="30103.1" href="<%- href %>">here</a>.',
            cn: '您输入的手机号或密码错误，请重试。如果您忘记了密码，请点击<a class="error-code-target" data-code="30103.1" href="<%- href %>">这里</a>。',
            tw: '您輸入的手機號或密碼錯誤，請重試。如果您忘記了密碼，請點擊<a class="error-code-target" data-code="30103.1" href="<%- href %>">這裡</a>。',
            jp: '入力した電話番号またはパスワードが間違っています。もう一度お試しください。パスワードをお忘れの場合、<a class="error-code-target" data-code="30103.1" href="<%- href %>">「こちら」</a>をクリックしてください。',
        };
    }
    if (code === 30103.2) { // 用户名密码错误
        data = {
            en: 'Incorrect username or password',
            cn: '用户名密码错误',
            tw: '用戶名密碼錯誤',
            jp: 'パスワードが間違っています。',
        };
    }
    if (code === 30103.3) {
        data = {
            en: 'Failed to set the new password. Please enter the correct old password.',
            cn: '新密码设置失败，请录入正确的原密码。',
            tw: '新密碼設置失敗，請錄入正確的原密碼。',
            jp: '新しいパスワードの設定に失敗しました。正しい元のパスワードを入力してください。',
        };
    }
    if (code === 30102) {
        title = {
            en: 'Account has been blocked',
            cn: '账号被禁用',
            tw: '賬號被禁用',
            jp: 'アカウントがブロックされています',
        };
        data = {
            en: 'Your account has been disabled due to illegal operations. If you have any questions about this, please contact your account manager.',
            cn: '您的账号存在非法操作，已被禁用。您如果对此存在疑问，请联系您的管理员。',
            tw: '您的賬號存在非法操作，已被禁用。您如果對此存在疑問，請聯繫您的管理員。',
            jp: '不正な操作によりお使いのアカウントが無効になりました。ご質問等ございましたら、御社のシステム管理者にお問い合わせください。',
        };
    }
    if (code === 30111 || code === 31621) {
        data = {
            en: 'Your account has not been authenticated. Please activate your account from your email. If you have not received your email, click <a class="error-code-target" data-code="30111" href="<%- href %>">here</a>.',
            cn: '您的账号还未认证，请到您的邮箱点击激活。如未收到邮件，点击<a class="error-code-target" data-code="30111" href="<%- href %>">这里</a>。',
            tw: '您的賬號還未認證，請到您的郵箱點擊激活。如未收到郵件，點擊<a class="error-code-target" data-code="30111" href="<%- href %>">這裡</a>。',
            jp: 'このアカウントはまだ認証されていません。弊社からのメールに記載されているリンクをクリックして、アカウントを有効にしてください。メールが見つからない場合には、<a class="error-code-target" data-code="30111" href="<%- href %>">ここ</a>をクリックしてください。',
        };
    }
    if (code === 30115 || code === 30106) {
        data = {
            en: 'Your account has not been activated yet.',
            cn: '您的账号没有访问该产品的权限，请联系智慧芽客服咨询。',
            tw: '您的賬號沒有訪問該產品的權限，請聯繫智慧芽客服諮詢。',
            jp: 'あなたのアカウントはこの機能にアクセスする権限がありません。お問合せまでご連絡ください。',
        };
    }

    if (code === 30104 || code === 4700) {
        data = {
            en: 'Your PatSnap account is in use on another device.',
            cn: '您的账号已在另一处登录使用',
            tw: '您的賬號已在另壹處登錄使用',
            jp: 'このIDは既に登録されています。',
        };
    }

    if (code === 30105) {
        data = {
            en: 'Account error.',
            cn: '服务器配置错误。',
            tw: '服務器配置錯誤。',
            jp: 'アカウントエラー',
        };
    }

    if (code === 30107 || code === 30305) {
        data = {
            en: 'Your account has expired.',
            cn: '您的账号已过期，请联系智慧芽客服咨询。',
            tw: '您的賬號已過期，請聯繫智慧芽客服諮詢。',
            jp: 'アカウントの有効期限が切れています。お問合せまでご連絡ください。',
        };
    }

    if (code === 30108 || code === 30301 || code === 30303) {
        data = {
            en: 'Please access the product within the specified IP range.<br>For security reasons, your company has limited access to our products within specified locations e.g.designated offices.',
            cn: '请在指定的IP范围内访问该产品。<br>您所在的组织希望您在指定地点（ 如办公室） 访问我们的产品。',
            tw: '請在指定的IP範圍內訪問該產品。<br>您所在的組織希望您在指定地點（ 如辦公室） 訪問我們的產品。',
            jp: '指定されたIP範囲内で本製品にアクセスしてください。<br>御社はセキュリティ上の理由により、 弊社の製品にアクセスする場所を限定しています（ 例えば、 御社のオフィス）。',
        };
    }

    if (code === 30109) {
        data = {
            en: 'Email is required.',
        };
    }

    if (code === 30130) {
        data = {
            en: 'This account has been disabled by your account manager. Please contact your company administrator for assistance.',
            cn: '您的账号已被公司管理员停用，请联系公司管理员启用账号。',
            tw: '您的賬號已被公司管理員停用，請聯繫公司管理員啟用賬號。',
            jp: '御社のID管理チームによってアカウントが停止され ています。御社のID管理チームまでご連絡ください。',
        };
    }

    if (code === 30131) {
        data = {
            en: 'Please activate your account by clicking on the link that was sent to your registered email address.',
            cn: '请点击发送到您注册邮箱中的链接，激活您的帐户',
            tw: '請點擊發送到您註冊郵箱中的鏈接，激活您的賬戶',
            jp: '確認メールのリンクをクリックすることにより、アカウントをアクティブ化してください',
        };
    }

    if (code === 30132) {
        title = {
            en: 'Your account has been blocked',
            cn: '账号被禁用',
            tw: '賬號被禁用',
            jp: 'アカウントがブロックされています',
        };
        data = {
            en: 'Your account has been blocked due to prohibited activity. Please contact your account manager to find out more information.',
            cn: '您的账号已被智慧芽管理员禁用，请联系智慧芽客服咨询。',
            tw: '您的賬號已被智慧芽管理員禁用，請聯繫智慧芽客服諮詢。',
            jp: '不正な操作によりお使いのアカウントが無効になりました。ご質問等ございましたら、御社のシステム管理者にお問い合わせください。',
        };
    }

    if (code === 30116) { // 邮箱密码
        title = {
            en: 'Your account has been locked',
            cn: '账号被锁定',
            tw: '賬號被鎖定',
            jp: 'アカウントはロックされています',
        };
        data = {
            en: 'Your account has been locked as you have reached the maximum number of failed login attempts. Please click <a class="error-code-target" data-code="30116" href="<%- href %>">here</a> to reactivate it.',
            cn: '密码错误次数到达上限，账号被锁定。为了您的账号安全，点击<a class="error-code-target" data-code="30116" href="<%- href %>">这里</a>重新激活账号。',
            tw: '密碼錯誤次數到達上限，賬號被鎖定。為了您的賬號安全，點擊<a class="error-code-target" data-code="30116" href="<%- href %>">這裡</a>重新激活賬號。',
            jp: 'パスワードのエラー回数が上限に達したため、アカウントがロックされました。お使いのアカウントの安全を保つために、<a class="error-code-target" data-code="30116" href="<%- href %>">ここ</a>をクリックしてアカウントを再度有効にしてください。',
        };
    }

    if (code === 30116.1) { // 手机号密码登录
        title = {
            en: 'Your account has been locked',
            cn: '账号被锁定',
            tw: '賬號被鎖定',
            jp: 'アカウントはロックされています',
        };
        data = {
            en: 'Your account has been locked as you have reached the maximum number of failed login attempts. Please retry after 30 minutes.',
            cn: '密码错误次数到达上限，账号被锁定，请于30分钟后重试。',
            tw: '密碼錯誤次數到達上限，賬號被鎖定，請於30分鐘後重試。',
            jp: 'パスワードによるログイン試行の失敗回数の上限に達したため、アカウントはロックされています。30分後に再試行してください。',
        };
    }

    if (code === 30179) { // 验证码错误次数达到上限
        title = {
            en: 'Your account has been locked',
            cn: '账号被锁定',
            tw: '賬號被鎖定',
            jp: 'アカウントはロックされています',
        };
        data = {
            en: 'Your account has been locked as you have reached the maximum number of failed login attempts. Please retry after 30 minutes.',
            cn: '验证码错误次数到达上限，账号被锁定，请于30分钟后重试。',
            tw: '驗證碼錯誤次數到達上限，賬號被鎖定，請於30分鐘後重試。',
            jp: '認証コードのエラー回数が上限に達し、アカウントがロックされます。30分後に再試行してください。',
        };
    }

    if (code === 30116.2) {
        data = {
            en: 'Your account has been locked as you have reached the maximum number of failed login attempts.',
            cn: '密码错误次数到达上限，账号被锁定。',
            tw: '密碼錯誤次數到達上限，賬號被鎖定。',
            jp: 'パスワードによるログイン試行の失敗回数の上限に達したため、アカウントはロックされています。',
        };
    }

    if (code === 31625) {
        data = {
            en: 'Too frequent operations, please contact your administrator to reset your password. ',
            cn: '操作过于频繁，请联系您的管理员重置密码。',
            tw: '操作過於頻繁，請聯繫您的管理員重置密碼。',
            jp: '操作過多です。パスワードのリセットをご希望の場合は、管理者に連絡してください。',
        };
    }

    if (code === 30311) {
        data = {
            en: 'The number of companies\' registered account has reached the upper limit',
            cn: '公司下账号注册数量已经到达上限。',
            tw: '公司下賬號註冊數量已經到達上限。',
            jp: '御社のユーザー数が上限に達しました。',
        };
    }

    if (code === 30302) {
        data = {
            en: 'Your organization has reached your limit for the number of concurrent users that can be logged in.',
            cn: '同时在线人数已达到预设上限',
            tw: '同時在線人數已達到預設上限',
            jp: '同時にログインできる上限を超えています',
        };
    }

    if (code === 30304) {
        data = {
            en: 'Account has not been activated.',
            cn: '账号尚未启用',
            tw: '賬號尚未啓用',
            jp: 'このアカウントはまだ利用されていません',
        };
    }

    if (code === 30307) {
        data = {
            en: 'Company can not be login by third party.',
            cn: '该公司不能被第三方登陆。',
            tw: '該公司不能被第三方登陸。',
            jp: 'この会社は第三者によってログインできません 。',
        };
    }

    if (code === 30401 || code === 20114 || code === 20115 || code === 20116 || code === 409) {
        data = {
            en: 'You have been logged out.',
            cn: '您已登出，请重新登录',
            tw: '您已登出，請重新登錄',
            jp: 'ログアウトされましたので、新たにご登録ください。',
        };
    }

    if (code === 30409) {
        title = {
            en: 'You\'ve been logged out',
            cn: '您已被登出',
            tw: '您已被登出',
            jp: 'ログアウトさせられました',
        };
        data = {
            en: 'Your were logged out of your account because your account is logged in to another browser or device.',
            cn: '由于您的账号在其它浏览器或电脑登录，本浏览器的账号被强制登出。',
            tw: '由於您的賬號在其它瀏覽器或電腦登錄，本瀏覽器的賬號被強制登出。',
            jp: 'お使いのアカウントは他のパソコンやブラウザでログインしているため、強制的にログアウトされました。',
        };
    }
    if (code === 30410) {
        title = {
            en: 'You\'ve been logged out',
            cn: '您已被登出',
            tw: '您已被登出',
            jp: 'ログアウトさせられました',
        };
        data = {
            en: 'The maximum number of individuals using the product at one time has been reached. You were logged out of your account.',
            cn: '由于您所在组织的同时在线人数到达上限，您的账号被强制登出。',
            tw: '由於您所在組織的同時在線人數到達上限，您的賬號被強制登出。',
            jp: '御社の同時接続数が上限に達したため、強制的にログアウトされました。',
        };
    }

    if (code === 30501) {
        data = {
            en: 'Role is not found.',
        };
    }

    if (code === 30502) {
        data = {
            en: 'Role is expired.',
        };
    }

    if (code === 30701) {
        data = {
            en: 'Sale is not found.',
        };
    }

    if (code === 10001 || code === 20000 || code === 20001 || code === 20002 || code === 20003 || code === 20004) {
        data = {
            en: 'Sorry, Bad request.',
        };
    }

    if (code === 10002) {
        data = {
            en: 'Service is not found.',
        };
    }

    if (code === 4033) {
        data = {
            en: 'Sorry, Permission Denied.',
        };
    }

    if (code === 30404 || code === 30405 || code === 30407) {
        data = {
            en: 'Your session has expired, please login again',
            cn: '会话已超时，请重新登录',
            tw: '會話已超時，請重新登錄',
            jp: 'セッションがタイムアウトしました。再度ログインしてご利用ください。',
        };
    }

    if (code === 30127) {
        data = {
            en: 'Your PatSnap account has been bound to another Wechat account, please unbind it and then login again',
            cn: '您的智慧芽账号已绑定其他微信账号，请先解绑再进行登录',
            tw: '您的智慧芽賬號已綁定其他微信賬號，請先解綁再進行登錄',
            jp: 'あなたのPatsnapアカウントは他のWeChatとバインディングを保持しています。バインディングを解除した後、再登録してください。',
        };
    }

    if (code === 30133 || code === 30134 || code === 30135 || code === 180203) {
        data = {
            en: 'Incorrect verification code',
            cn: '验证码错误',
            tw: '驗證碼錯誤',
            jp: '認証コードが間違っています',
        };
    }

    if (code === 180107) {
        data = {
            en: 'The verification link has expired.',
            cn: '您的验证链接已经失效。',
            tw: '您的驗證鏈接已經失效。',
            jp: '検証リンクの有効期限が切れました。',
        };
    }

    if (code === 180108) {
        data = {
            en: 'The verification link has expired. <a class="error-code-target" data-code="180108" href="<%- href %>">Click</a> to resend.',
            cn: '您的邮箱验证链接已经失效，<a class="error-code-target" data-code="180108" href="<%- href %>">点击</a>重新发送。',
            tw: '您的郵箱驗證鏈接已經失效，<a class="error-code-target" data-code="180108" href="<%- href %>">點擊</a>重新發送。',
            jp: 'メール検証リンクの有効期限が切れました。「<a class="error-code-target" data-code="180108" href="<%- href %>">再送</a>」をクリックしてください。',
        };
    }

    if (code === 180201) {
        data = {
            en: 'Page request was expired.Please try again.',
            cn: '页面过期，请刷新重试',
            tw: '頁面過期，請刷新重試',
            jp: 'ページの有効期限が切れました、もう一度やり直してください',
        };
    }

    if (code === 180106) {
        data = {
            en: 'The reset password link has expired. <a class="error-code-target" data-code="180106" href="<%- href %>">Click</a> to resend.',
            cn: '您的重置密码验证链接已经失效，<a class="error-code-target" data-code="180106" href="<%- href %>">点此</a>重新发送。',
            tw: '您的重置密碼驗證鏈接已經失效，<a class="error-code-target" data-code="180106" href="<%- href %>">點此</a>重新發送。',
            jp: 'パスワードのリセットリンクの有効期限が切れています。リセットリンクを再送信するには、<a class="error-code-target" data-code="180106" href="<%- href %>">ここをクリック</a>してください。',
        };
    }

    if (code === 40001) {
        data = {
            en: 'The account binding link was invalid',
            cn: '您的账号绑定链接无效',
            tw: '您的賬號綁定鏈接無效',
            jp: '無効なアカウントバインディングリンク',
        };
    }

    if (code === 40002) {
        data = {
            en: 'The account binding link was expired',
            cn: '您的账号绑定链接已过期',
            tw: '您的賬號綁定鏈接已過期',
            jp: 'アカウントバインドリンクの有効期限が切れています',
        };
    }

    if (code === 31606) {
        data = {
            en: 'The account binding link was expired',
            cn: '您的账号绑定链接已失效',
            tw: '您的賬號綁定鏈接已失效',
            jp: 'アカウントバインドリンクの有効期限が切れています',
        };
    }

    if (code === 30122) {
        data = {
            en: 'Your account has not been verified. We recommend you verify and login using SMS.',
            cn: '您的账号还没有验证通过。建议您直接通过短信登录。',
            tw: '您的賬號還沒有驗證通過。建議您直接通過短信登錄。',
            jp: 'アカウントが検証されていません。SMSでログインすることをお勧めします。',
        };
    }

    if (code === 30119 || code === 30101.1 || code === 30155) {
        data = {
            en: 'Verification code error or timeout detected.',
            cn: '验证码错误或超时。',
            tw: '驗證碼錯誤或超時。',
            jp: '検証コードが間違いましたかタイムアウトしました。',
        };
    }

    if (code === 30101.2) {
        data = {
            en: 'Your number does not exist, please sign up.',
            cn: '您的号码不存在，请先注册。',
            tw: '您的號碼不存在，請先註冊。',
            jp: 'あなたの番号は存在しません。先に登録してください。',
        }
    }

    if (code === 31002) {
        data = {
            en: 'Failed to send the verification code.',
            cn: '验证码发送失败。',
            tw: '驗證碼發送失敗。',
            jp: '検証コードの送信に失敗しました。',
        };
    }

    if (code === 30143 || code === 610003 || code === 30156) { // 验证码发送过于频繁
        data = {
            en: 'The verification code has been requested too frequently. Please try again later.',
            cn: '验证码发送过于频繁，请稍后再试。',
            tw: '驗證碼發送過于頻繁，請稍後再試。',
            jp: '検証コードを過度に頻繁に送信しています。時間をおいてお試しください。',
        };
    }

    if (code === 31007 || code === 31008) { // 已经达到您在控制台设置的短信日发送量限额值
        data = {
            en: 'The verification code has been requested too frequently. Please try again tomorrow.',
            cn: '验证码发送过于频繁，请明天再试。',
            tw: '驗證碼發送過於頻繁，請明天再試。',
            jp: '検証コードを過度に頻繁に送信しています。明日試してみてください。',
        };
    }

    if (code === 31009) { // 手机号码格式错误。
        data = {
            en: 'Wrong mobile number. Please check for typing errors.',
            cn: '手机号不正确，请检查是否有录入错误。',
            tw: '手機號不正確，請檢查是否有錄入錯誤。',
            jp: '携帯電話番号が正しくありません。入力エラーがないか確認してください。',
        };
    }

    // 极验和recapture错误码
    if (code === 20220111 || code === 20220112 || code === 20220113) {
        data = {
            en: 'Your network environment is unstable, man-machine verification failed, please try again later..',
            cn: '您的网络环境不稳定，人机验证失败，请稍侯再试。',
            tw: '您的網絡環境不穩定，人機驗證失敗，請稍侯再試。',
            jp: 'ネットワーク環境が不安定で、ヒューマンマシンの検証に失敗しました。しばらく待ってから試してください。',
        };
    }

    // success Code
    if (code === 20001) {
        data = {
            en: 'Thank you for registering on PatSnap. To activate your account, please click the link in the activation email which has been sent to you.',
            cn: '感谢您注册智慧芽账号，我们已经发给您一封激活邮件，请点击邮件内链接完成注册',
            tw: '感謝您注冊智慧芽賬號，我們已經發給您壹封激活郵件，請點擊郵件內鏈接完成注冊',
            jp: 'PatSnap アカウントを登録していただきありがとうございます，有効化のメッセージをお送りしました，登録を完了するにはメール内のリンクをクリックしてください',
        };
    }
    if (code === 20002) {
        data = {
            en: 'Your password has been changed successfully.',
            cn: '修改密码成功',
            tw: '修改密碼成功',
            jp: 'Yパスワードを正常に変更する',
        };
    }
    if (code === 20003) {
        data = {
            en: 'Your account has been activated.',
            cn: '恭喜您，账号已激活',
            tw: '恭喜您，賬號已激活',
            jp: 'あなたにおめでとう，あなたのアカウント活性化された',
        };
    }
    if (code === 20004) {
        title = {
            en: 'The verification code has been sent. ',
            cn: '验证码发送成功',
            tw: '驗證碼發送成功',
            jp: '検証コードを送信しました。',
        };
        data = {
            en: 'A text message with a 6-digit verification code was just sent to <%- userMobileNumber %>, The verification code is valid for 10 minutes.',
            cn: '系统刚刚通过短信将一个 6 位数的验证码发送到了以下号码：<%- userMobileNumber %>，该验证码10分钟内有效。',
            tw: '系統剛剛通過短信將一個 6 位數的驗證碼發送到了以下號碼：<%- userMobileNumber %>，該驗證碼10分鐘內有效。',
            jp: '6桁の検証コードを含むショートメッセージを<%- userMobileNumber %>という番号の携帯にお送りしました。該検証コードは10分間内に有効です。',
        };
    }

    if (code === 30142) {
        title = {
            en: 'Please login via SSO',
            cn: '请通过SSO方式登录',
            tw: '請通過SSO方式登錄',
            jp: 'SSO方式でログインしてください',
        };
        data = {
            en: 'Your administrator requires you to login via SSO to access PatSnap products.Please access PatSnap through your internal authentication server.',
            cn: '您的管理员要求您通过SSO方式登录智慧芽产品。请通过您的内部认证服务器来访问智慧芽。',
            tw: '您的管理員要求您通過SSO方式登錄智慧芽產品。請通過您的內部認證服務器來訪問智慧芽。',
            jp: '管理者の要求により、SSO方式でPatSnap製品にログインする必要があります。内部認証サーバーを介してスマートバッドにアクセスしてください。',
        };
        if (loginUrl) {
            const link = `<a class="error-code-target" data-code="30142" href="${loginUrl}">${loginUrl}</a>`;
            data = {
                en: `${data.en}Click the following link to redirect to your authentication server.}<br/>${link}`,
                cn: `${data.cn}点击下方链接跳转到您的认证服务器。<br/>${link}`,
                tw: `${data.tw}點擊下方鏈接跳轉到您的認證服務器。<br/>${link}`,
                jp: `${data.jp}以下のリンクをクリックすると、認証サーバーにジャンプします。<br/>${link}`,
            };
        }
    }

    if (code === 30145) {
        data = {
            en: 'Your organization requires you to use your business email address to access PatSnap. Please login via email.',
            cn: '您所在的组织要求您使用商务邮箱访问智慧芽，请通过邮箱登录。',
            tw: '您所在的組織要求您使用商務郵箱訪問智慧芽，請通過郵箱登錄。',
            jp: 'ご所属の組織では、ビジネス用メールアドレスを用いてPatSnapにアクセスすることを要求されていますため、メールアドレスでログインしてください。',
        };
    }

    if (code === 30152) {
        title = {
            en: 'Update password',
            cn: '修改密码',
            tw: '修改密碼',
            jp: 'パスワードの変更',
        };
        data = {
            en: 'Your organization has asked you to reset your password to secure your account. Please login and reset your password.',
            cn: '您所在的企业要求您重设密码。请重新登录，并设置密码。',
            tw: '您所在的企業要求您重設密碼。請重新登錄，並設置密碼。',
            jp: 'パスワードを変更するように会社から要求されました。 再度ログインしてパスワードを変更してください。',
        };
    }

    // 登录跳重置密码链接已过期，请重新登录
    if (code === 180117 || code === 180202) {
        data = {
            en: 'Your session has expired, please login again',
            cn: '会话已超时，请重新登录',
            tw: '會話已超時，請重新登錄',
            jp: 'セッションがタイムアウトしました。再度ログインしてご利用ください。',
        };
    }

    // 弱密码校验失败
    if (code === 30153) {
        data = {
            en: 'The password can contain only letters, digits, and English symbols, must contain letters and digits, and length is 8 to 32.',
            cn: '密码仅可由数字，字母，与英文符号组成，必须包含数字与字母，长度为8-32。',
            tw: '密碼僅可由數字，字母，與英文符號組成，必須包含數字與字母，長度為8-32。',
            jp: 'パスワードは、数字、文字、英字記号のみで構成でき、数字と文字を含める必要があり、長さは 8 ～ 32 です。',
        };
    }

    // 强密码校验失败
    if (code === 30123) {
        data = {
            en: 'Password must be 12 - 32 characters long and include uppercase and lowercase letters, digits, and English characters.',
            cn: '密码长度为12-32位字符，必须包含大小写字母，数字，英文符号。',
            tw: '密碼長度為12-32位字符，必須包含大小寫字母，數字，英文符號。',
            jp: 'パスワードの長さは12～32文字で、大文字と小文字、数字、および英語の記号を含める必要があります。',
        };
    }

    // 不可与上三次相同
    if (code === 30151) {
        data = {
            en: 'The new password cannot be the same as the last three passwords.',
            cn: '新密码不可与最近3次的密码相同。',
            tw: '新密碼不可與最近3次的密碼相同。',
            jp: '新しいパスワードは、この前に使っていた3つのパスワードと異なるものにしてください。',
        };
    }

    // 账号已经与其他SAML uid绑定
    if (code === 30157) {
        data = {
            en: 'Your account has already bound to another SAML UID',
            cn: '您的帐户已经绑定另一SAML UID',
            tw: '您的帳戶已經綁定另一SAML UID',
            jp: 'アカウントは別のSAMLUIDにバインドされています',
        };
    }

    // 公司 dingtalk缺少配置（缺少aapKey appSecret 等）
    if (code === 30319) {
        data = {
            en: 'Please contact your administrator to modify the configuration of DingTalk.',
            cn: '请联系您的管理员修改钉钉的配置。',
            tw: '請聯繫您的管理員修改釘釘的配置。',
            jp: '管理者に連絡してDingTalkの設定を変更してください。',
        };
    }

    // sso 登陆的时候没有命中对应的公司
    if (code === 30318) {
        data = {
            en: 'Your organization is not enabled to login to PatSnap through {OA}. Please contact your administrator to enable SSO via the Admin Portal.',
            cn: '您的组织未开启通过{OA}登录智慧芽。请联系您的管理员到智慧芽管理员工作台开启。',
            tw: '您的組織未開啟通過{OA}登錄智慧芽。請聯繫您的管理員到智慧芽管理員工作台開啟。',
            jp: 'あなたの組織は、{OA}によるPatSnapログインを有効していません。 管理ポータルで有効にすることができますが、管理者に連絡してください。',
        };
    }

    // 邮箱与手机号命中了两个不同的账号
    if (code === 30154 || code === 1804128) {
        data = {
            en: 'We have identified two accounts with your email and phone number.',
            cn: '根据您的邮箱与手机号查到了2个账号。',
            tw: '根據您的郵箱與手機號查到了2個賬號。',
            jp: 'あなたのメールアドレスと携帯電話番号に基づいて、２つのアカウントを見つけました。',
        };
    }

    // 钉钉sso 登录开关没有打开
    if (code === 30160) {
        data = {
            en: 'Your organization is not enabled to login to PatSnap through {OA}. Please contact your administrator to enable SSO via the Admin Portal.',
            cn: '您的组织未开启通过{OA}登录智慧芽。请联系您的管理员到智慧芽管理员工作台开启。',
            tw: '您的組織未開啟通過{OA}登錄智慧芽。請聯繫您的管理員到智慧芽管理員工作台開啟。',
            jp: 'あなたの組織は、{OA}によるPatSnapログインを有効していません。 管理ポータルで有効にすることができますが、管理者に連絡してください。',
        };
    }

    // 企业微信 sso登录开关没有打开
    if (code === 30161) {
        data = {
            en: 'Your organization is not enabled to login to PatSnap through {OA}. Please contact your administrator to enable SSO via the Admin Portal.',
            cn: '您的组织未开启通过{OA}登录智慧芽。请联系您的管理员到智慧芽管理员工作台开启。',
            tw: '您的組織未開啟通過{OA}登錄智慧芽。請聯繫您的管理員到智慧芽管理員工作台開啟。',
            jp: 'あなたの組織は、{OA}によるPatSnapログインを有効していません。 管理ポータルで有効にすることができますが、管理者に連絡してください。',
        };
    }

    // 飞书sso 登录开关没有打开
    if (code === 30162) {
        data = {
            en: 'Your organization is not enabled to login to PatSnap through {OA}. Please contact your administrator to enable SSO via the Admin Portal.',
            cn: '您的组织未开启通过{OA}登录智慧芽。请联系您的管理员到智慧芽管理员工作台开启。',
            tw: '您的組織未開啟通過{OA}登錄智慧芽。請聯繫您的管理員到智慧芽管理員工作台開啟。',
            jp: 'あなたの組織は、{OA}によるPatSnapログインを有効していません。 管理ポータルで有効にすることができますが、管理者に連絡してください。',
        };
    }

    // 邮箱账号必填一个
    if (code === 30166) {
        data = {
            en: 'Please enter either your email address or mobile number.',
            cn: '邮箱与手机必需录入任意一个。',
            tw: '郵箱與手機必需錄入任意一個。',
            jp: 'メールアドレスまたは携帯電話番号を入力する必要があります。',
        };
    }
    if (code === 30168) {
        data = {
            en: 'Please authorize either your email address or mobile number.',
            cn: '邮箱与手机必须授权任意一个。',
            tw: '郵箱與手機必須授權任意一個。',
            jp: 'メールアドレスまたは携帯電話番号を承認するする必要があります。',
        };
    }

    // UID，Email，手机号全未传
    if (code === 31601) {
        data = {
            en: 'Your account could not be identified. Contact your administrator to modify the authorization configuration of {OA}. Only one of the following needs to be authorized: user ID, email address, or mobile number.',
            cn: '无法识别您的身份。请联系您的管理员修改{OA}的授权配置。仅需授权用户ID，邮箱或手机中的任一个。',
            tw: '無法識別您的身份。請聯繫您的管理員修改{OA}的授權配置。僅需授權用戶ID，郵箱或手機中的任一個。',
            jp: 'あなたの身分は確認できません。管理者に連絡して、{OA}の権限設定を変更してください。 ユーザIDとメールアドレスのうちのいずれか１つに権限を与えるだけでいいです。',
        };
    }

    // 微信授权失败
    if (code === 31602) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of WeCom.',
            cn: '请联系您的管理员修改企业微信的授权配置。',
            tw: '請聯繫您的管理員修改企業微信的授權配置。',
            jp: '管理者に連絡してWeChat Workの権限設定を変更してください。',
        };
    }

    // 飞书授权失败
    // 31607: company.feishu.setting.by.appId.is.null
    // 31608: feishu.setting.appId.or.appSecret.not.found
    // 31616: feishu app access token is error
    // 31610: feishu access token is invalid
    // 31609: Get feishu user info error

    if (code === 31616 || code === 31610 || code === 31609 || code === 31607 || code === 31608) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of FeiShu.',
            cn: '请联系您的管理员修改飞书的授权配置。',
            tw: '請聯繫您的管理員修改飛書的授權配置。',
            jp: '管理者に連絡してFeiShuの権限設定を変更してください。',
        };
    }

    // 获取钉钉userinfo失败
    if (code === 31603) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of DingTalk.',
            cn: '请联系您的管理员修改钉钉的授权配置。',
            tw: '請聯繫您的管理員修改釘釘的授權配置。',
            jp: '管理者に連絡してDingTalkの権限設定を変更してください。',
        };
    }

    // 获取钉钉userId失败
    if (code === 31604) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of DingTalk.',
            cn: '请联系您的管理员修改钉钉的授权配置。',
            tw: '請聯繫您的管理員修改釘釘的授權配置。',
            jp: '管理者に連絡してDingTalkの権限設定を変更してください。',
        };
    }

    // 获取钉钉access token失败
    if (code === 31605) {
        data = {
            en: 'Please contact your administrator to modify the configuration of DingTalk.',
            cn: '请联系您的管理员修改钉钉的配置。',
            tw: '請聯繫您的管理員修改釘釘的配置。',
            jp: '管理者に連絡してDingTalkの設定を変更してください。',
        };
    }

    if (code === 30139 || code === 30172 || code === 30171) {
        data = {
            en: 'Please use your organization\'s business email address to register and use PatSnap.',
            cn: '请使用您所在组织的商务邮箱注册并使用智慧芽产品。',
            tw: '請使用您所在組織的商務郵箱註冊並使用智慧芽產品。',
            jp: '組織のビジネスメールアドレスを使用してPatSnapに登録して製品をご利用ください。',
        };
    }

    // 公司开启carsi用户登录domain不符合该企业的域名列表
    if (code === 30169) {
        data = {
            en: 'Your organization requires you to use your business email address to access PatSnap.',
            cn: '您所在的组织要求您使用商务邮箱访问智慧芽。',
            tw: '您所在的組織要求您使用商務郵箱訪問智慧芽。',
            jp: 'ご所属の組織では、ビジネス用メールアドレスを用いてPatSnapにアクセスすることを要求されていますため。',
        };
    }

    if (code === 30129) {
        data = {
            en: 'Email address already exists.',
            cn: '邮箱已经存在。',
            tw: '郵箱已經存在。',
            jp: 'このメールアドレスは登録済みです。',
        };
    }

    // CARSI 登录
    if (code === 30182) {
        data = {
            en: 'The account is required to log in through CARSI as per the affiliated school\'s request. You can log in using CARSI by unbinding the school account through the personal center first, and then follow this method for login.',
            cn: '帐号所属学校要求CARSI登录，请通过CARSI登录。您可以通过个人中心解绑学校帐号后，再按照该方式登录。',
            tw: '帳號所屬學校要求CARSI登錄，請通過CARSI登錄。您可以通過個人中心解綁學校帳號後，再按照該方式登錄。',
            jp: 'アカウントが所属する学校はCARSIログインを要求しています。CARSIを使用してログインしてください。学校アカウントのバインドを解除するには、まず個人センターを使用し、その後この方法に従ってログインしてください。',
        }
    }

    // 180406jwt  31620google认证过期
    if (code === 180406 || code === 31620) {
        data = {
            en: 'The authentication information has expired. Please try again.',
            cn: '认证信息过期，请重试。',
            tw: '認證信息過期，請重試。',
            jp: 'The authentication information has expired. Please try again.',
        };
    }

    if (code === 31611) {
        data = {
            en: 'The authentication information has expired, please click the PatSnap App in the DingTalk again.',
            cn: '认证信息过期，请重新在钉钉中点击智慧芽应用App。',
            tw: '認證信息過期，請重新在釘釘中點擊智慧芽應用App。',
            jp: 'The authentication information has expired, please click the PatSnap App in the DingTalk again.',
        };
    }

    if (code === 31612) {
        data = {
            en: 'The authentication information has expired, please click the PatSnap App in the WeCom again.',
            cn: '认证信息过期，请重新在企业微信中点击智慧芽应用App。',
            tw: '認證信息過期，請重新在企業微信中點擊智慧芽應用App。',
            jp: 'The authentication information has expired, please click the PatSnap App in the WeCom again.',
        };
    }

    if (code === 31613) {
        data = {
            en: 'The authentication information has expired, please click the PatSnap App in the Feishu again.',
            cn: '认证信息过期，请重新在飞书中点击智慧芽应用App。',
            tw: '認證信息過期，請重新在飛書中點擊智慧芽應用App。',
            jp: 'The authentication information has expired, please click the PatSnap App in the Feishu again.',
        };
    }

    if (code === 31616) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of DingTalk, or enter your email information in the Contacts.',
            cn: '请联系您的管理员修改钉钉的授权配置，或在企业通迅录里录入您的邮箱信息。',
            tw: '請聯系您的管理員修改釘釘的授權配置，或在企業通迅錄裏錄入您的郵箱信息。',
            jp: 'Please contact your administrator to modify the authorization configuration of DingTalk, or enter your email information in the Contacts.',
        };
    }

    if (code === 31617) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of WeCom, or enter your email information in the Contacts.',
            cn: '请联系您的管理员修改企业微信的授权配置，或在企业通迅录里录入您的邮箱信息。',
            tw: '請聯系您的管理員修改企業微信的授權配置，或在企業通迅錄裏錄入您的郵箱信息。',
            jp: 'Please contact your administrator to modify the authorization configuration of WeCom, or enter your email information in the Contacts.',
        };
    }

    if (code === 31618) {
        data = {
            en: 'Please contact your administrator to modify the authorization configuration of FeiShu, or enter your email information in the Member and Department.',
            cn: '请联系您的管理员修改飞书的授权配置，或在成员与部门中录入您的邮箱信息。',
            tw: '請聯系您的管理員修改飛書的授權配置，或在成員與部門中錄入您的郵箱信息。',
            jp: 'Please contact your administrator to modify the authorization configuration of FeiShu, or enter your email information in the Member and Department.',
        };
    }

    if (code === 30173) {
        title = {
            en: 'Please login via DingTalk',
            cn: '请通过钉钉登录',
            tw: '請通過釘釘登錄',
            jp: 'DingTalk方式でログインしてください',
        };
        data = {
            en: 'Your administrator requires you to login via DingTalk to access PatSnap.',
            cn: '您的管理员要求您通过钉钉的智慧芽应用登录。',
            tw: '您的管理員要求您通過釘釘的智慧芽應用登錄。',
            jp: '管理者の要求により、 DingTalk方式でPatsnap製品にログインする必要があります。',
        };
    }
    if (code === 30175) {
        title = {
            en: 'Please login via Feishu',
            cn: '请通过飞书登录',
            tw: '請通過飛書登錄',
            jp: 'Feishu方式でログインしてください',
        };
        data = {
            en: 'Your administrator requires you to login via Feishu to access PatSnap.',
            cn: '您的管理员要求您通过飞书的智慧芽应用登录。',
            tw: '您的管理員要求您通過飛書的智慧芽應用登錄。',
            jp: '管理者の要求により、 Feishu方式でPatsnap製品にログインする必要があります。',
        };
    }
    if (code === 30174) {
        title = {
            en: 'Please login via WeCom',
            cn: '请通过企业微信登录',
            tw: '請通過企業微信登錄',
            jp: 'WeCom方式でログインしてください',
        };
        data = {
            en: 'Your administrator requires you to login via WeCom to access PatSnap.',
            cn: '您的管理员要求您通过企业微信的智慧芽应用登录。',
            tw: '您的管理員要求您通過企業微信的智慧芽應用登錄。',
            jp: '管理者の要求により、 WeCom方式でPatsnap製品にログインする必要があります。',
        };
    }
    if (code === 30176) {
        title = {
            en: 'Please login via Internal Authentication Server',
            cn: '请通过内部认证服务器登录',
            tw: '請通過內部認證服務器登錄',
            jp: 'SSO方式でログインしてください',
        };
        data = {
            en: 'Your administrator requires you to login via Internal Authentication Server to access PatSnap.',
            cn: '您的管理员要求您通过内部认证服务器的智慧芽应用登录。',
            tw: '您的管理員要求您通過內部認證服務器的智慧芽應用登錄。',
            jp: '管理者の要求により、 SSO方式でPatsnap製品にログインする必要があります。',
        };
    }

    if (code === 30177) {
        data = {
            en: 'Sorry, your email is null or not verified, please go to Account - Personal Information to verify.',
            cn: '您的邮箱未设置或未认证，请去用户设置-个人信息中认证邮箱',
            tw: '您的郵箱未設定或未認證，請去用戶設置-個人資訊中認證郵箱',
            jp: 'あなたのメールアドレスは検証されていません。アカウント-個人情報に移動してメール検証を完了してください。',
        };
    }

    if (code === 30801) {
        data = {
            en: 'Sorry, the company you will join is not exist.',
            cn: '抱歉，您要加入的公司不存在。',
            tw: '抱歉，您要加入的公司不存在。',
            jp: '申し訳ありませんが、あなたが入社しようとしている会社は存在しません。',
        };
    }

    if (code === 30803) {
        data = {
            en: 'Sorry, this company you have already joined',
            cn: '您已加入该公司，请勿重复加入。',
            tw: '您已加入該公司，請勿重複加入。',
            jp: 'あなたはすでにこの会社に参加しています。再度参加しないでください。',
        };
    }

    if (code === 30804) {
        data = {
            en: 'Sorry, your privilege has been removed, please contact the administrator. ',
            cn: '您的账号已被移除，要想重新加入，请联系您的企业管理员。',
            tw: '您的賬號已被移除，要想重新加入，請聯系您的企業管理員。',
            jp: 'アクセス権が削除されました。再度参加するには、管理者に問い合わせてください。',
        };
    }

    if (code === 10004) {
        data = {
            en: 'Sorry, your email address is not suited for registration, please contact the administrator. ',
            cn: '抱歉，您的邮箱不符合贵司要求，请联系您的企业管理员。',
            tw: '抱歉，您的郵箱不符合貴司要求，請聯繫您的企業管理員。',
            jp: '申し訳ありませんが、あなたの電子メール アドレスは会社の要件を満たしていません。エンタープライズ管理者にお問い合わせください。',
        };
    }

    if (code === 30324) {
        data = {
            en: 'The company does not allow domain name registration, please contact your administrator.',
            cn: '公司并未允许域名注册，请联系您的企业管理员。',
            tw: '公司並未允許功能變數名稱註冊，請聯系您的企業管理員。',
            jp: '会社はドメイン名の登録を許可していません。会社の管理者に問い合わせてください。',
        };
    }

    if (code === 30167) {
        data = {
            en: 'The account already exists, please do not add it again.',
            cn: '账号已经存在，请勿重复添加。',
            tw: '賬號已經存在，請勿重複添加。',
            jp: 'アカウントはすでに存在します。再度追加しないでください。',
        };
    }

    if (code === 31701) {
        data = {
            en: 'Your invitation link is expired or invalid, please contact your administrator to get a new link.',
            cn: '您的邀请链接已过期或无效，请联系您的管理员生成新链接。',
            tw: '您的邀請鏈接已過期或無效，請聯系您的管理員生成新鏈接。',
            jp: '招待リンクの有効期限が切れているか無効です。管理者に連絡して、新しいリンクを生成してください。',
        };
    }

    if (code === 31627) {
        data = {
            en: 'OAuth2.0 configuration error missing.',
            cn: 'OAuth2.0 配置缺失错误',
            tw: 'OAuth2.0 配置缺失錯誤',
            jp: 'OAuth2.0設定エラーがあります。',
        };
    }
    if (code === 31628) {
        data = {
            en: 'OAuth2.0 configuration error, clientId or ClientSecret is empty, or the configuration is incorrect.',
            cn: 'OAuth2.0 配置错误，clientId ClientSecret 为空，或者配置错误',
            tw: 'OAuth2.0 配置錯誤，clientId ClientSecret 為空，或者配置錯誤',
            jp: 'OAuth2.0の設定エラー、clientIdまたはClientSecretが空、または設定が間違っています。',
        };
    }
    if (code === 31629) {
        data = {
            en: 'OAuth2.0 authentication information lacks email information.',
            cn: 'OAuth2.0 认证信息中缺少 email 信息',
            tw: 'OAuth2.0 認證資訊中缺少 email 資訊',
            jp: 'OAuth2.0の認証情報に email 情報が不足しています。',
        };
    }
    if (code === 30325) {
        data = {
            en: 'OAuth2.0 switch is not turned on.',
            cn: 'OAuth2.0 开关未打开',
            tw: 'OAuth2.0 開關未打開',
            jp: 'OAuth2.0のスイッチがオンになっていません。',
        };
    }
    if (code === 180104) {
        data = {
            en: 'Invalid email in OAuth2.0 Authentication.',
            cn: 'OAuth2.0 Authentication 的邮箱不合法',
            tw: 'OAuth2.0 Authentication 的電郵不合法',
            jp: 'OAuth2.0 Authenticationのメールが無効です。',
        };
    }

    if (code === 30183) {
        data = {
            en: 'Please enter a valid mobile number to register for a Patsnap account.',
            cn: '请输入真实的手机号注册智慧芽账号。',
            tw: '請輸入真實的手機號註冊智慧芽賬號。',
            jp: '有効な携帯電話番号を入力してPatsnapアカウントに登録してください。',
        };
    }

    if (code && (!data[lang] || !data.en)) {
        data = {
            en: 'An unknown error has occurred. Please contact us if you need any help.',
            cn: '发生未知错误，需要帮助请联系我们',
            tw: '發生未知錯誤，需要幫助請聯繫我們',
            jp: '不明なエラーが発生しました。Patsnapカスタマーサービスまでご連絡ください。',
        };
    }

    /**
     * 不做错误提示
     */
    if (code === 39999 || code === 30411 || code === 30412 || code === 30413) {
        data = {
            en: '',
        };
    }

    return {
        title: title[lang] || title.en,
        msg: data[lang] || data.en,
    };
}

export function getOutLinkByErrorCode({
    code,
    serviceArea,
    userEmail,
    paramsUrl,
}) {
    const linkErrorCodeMap = {
        30101: {
            cn: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            us: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            eu: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
        },
        30103: {
            cn: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            us: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            eu: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
        },
        180102: {
            cn: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            us: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            eu: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
        },
        30103.1: {
            cn: '/public/?landing=true&<%= paramsUrl %>#/forgetPassword',
            us: '/public/?landing=true&<%= paramsUrl %>#/forgetPassword',
            eu: '/public/?landing=true&<%= paramsUrl %>#/forgetPassword',
        },
        30113: {
            cn: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            us: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            eu: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
        },
        180106: {
            cn: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            us: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
            eu: '/public/?landing=true&<%= paramsUrl %>#/forgetPasswordEmail',
        },
        30111: {
            cn: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
            us: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
            eu: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
        },
        31621: {
            cn: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
            us: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
            eu: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
        },
        180108: {
            cn: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
            us: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
            eu: '/public/?<%= paramsUrl %>#/resendActive?email=<%- userEmail %>',
        },
        30116: {
            cn: '/public/?<%= paramsUrl %>#/unlockUser?email=<%- userEmail %>',
            us: '/public/?<%= paramsUrl %>#/unlockUser?email=<%- userEmail %>',
            eu: '/public/?<%= paramsUrl %>#/unlockUser?email=<%- userEmail %>',
        },
    };
    let link = linkErrorCodeMap[code] && linkErrorCodeMap[code][serviceArea];
    const urlEnv = window.location.host.split('-')[0];
    const protocol = window.location.protocol;
    const envList = ['ci', 'qa', 'release'];
    let env = '';
    if (_.includes(envList, urlEnv)) {
        env = `${urlEnv}-`;
    }
    if (link) {
        link = _.template(link)({
            userEmail,
            protocol,
            env,
            paramsUrl,
        });
    }
    return link;
}

export function getAlertDataByCode({
    code,
    lang,
    serviceArea,
    userEmail,
    loginUrl,
    userMobileNumber,
    paramsUrl,
    account,
}) {
    let { title, msg } = getMessageByCodeAndLanguage({ code, lang, loginUrl });
    const link = getOutLinkByErrorCode({
        code,
        serviceArea,
        userEmail,
        paramsUrl,
    });
    msg = _.template(msg)({
        href: link,
        userMobileNumber,
        account,
    });
    const errorData = {
        title,
        msg,
    };
    return errorData;
}
